exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap);", ""]);

// module
exports.push([module.id, ".v-application--wrap{background-color:#f5f5f5}.subtitle{font-size:30px;font-family:Poppins,sans-serif;color:#008dd4}@media (max-width:600px){.subtitle{font-size:15px}}", ""]);

// exports
